import React from "react";
import PageHeader from "components/common/PageHeader";
import EmbeddedMimecastApp from "./EmbeddedMimecastApp";
const MimecastApp = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: "Mimecast input" }, /* @__PURE__ */ React.createElement("span", null, "This input retrieves log records from Mimecast.")), /* @__PURE__ */ React.createElement(EmbeddedMimecastApp, null));
export default MimecastApp;
